<template>
  <div class="course-schedule-container">
    <!-- 新-自动排课表 -->
    <div class="course-back-color-list">
      <div class="color-item" v-for="item in classList" :key="item.classCode">
        <span>{{ item.className }}：</span>
        <!-- <el-color-picker v-model="item.backgroundColor" disabled></el-color-picker> -->
        <div class="color-box" :style="{
          backgroundColor: item.backgroundColor,
        }"></div>
      </div>
    </div>
    <div class="curriculum-table-container" v-if="courseSchedule.length">
      <!-- 表头容器 -->
      <div class="table-header-container">
        <div style="display: flex;">
          <!-- 课节 -->
          <div class="table-header-label lesson-label">
            <span>课节</span>
          </div>
          <div class="table-header-label lesson-label">
            <span>顺序</span>
          </div>
          <!-- 时间 -->
          <div class="table-header-label time-label">时间</div>
        </div>
        <!-- 周一至周日 -->
        <div style="display: flex;">
          <div class="table-header-label" v-for="(weekItem, weekIndex) in 7" :key="weekIndex" :style="weekItemStyle()">
            星期{{
              weekIndex + 1 == 7 ? "天" : digitalToChineseWeek(weekIndex + 1)
            }}
          </div>
        </div>
      </div>
      <!-- 表格横向容器 -->
      <div class="table-row-item-container" v-for="(lessonRowItem, lessonRowIndex) in courseSchedule[0]
        .scheduleList" :key="lessonRowIndex">
        <div class="lesson-container">
          <!-- 课节名 -->
          <div class="table-row-item lesson-label-item">
            <span>{{ lessonRowItem.lessonsName }}</span>
          </div>
          <!-- 课节顺序 -->
          <div class="table-row-item lesson-label-item">
            {{
              lessonRowItem.lessonsSequence == -1
                ? ""
                : lessonRowItem.lessonsSequence
            }}
          </div>
          <!-- 时间 -->
          <div class="table-row-item time-item">
            <div class="time-gettime">
              <span class="time-value">{{ lessonRowItem.startTime }}</span>至<span class="time-value">{{
                lessonRowItem.endTime
              }}</span>
            </div>
          </div>
        </div>
        <!-- 周一至周日课节 -->
        <div class="lesson-list-container">
          <div class="lesson-content-list" v-for="(lessonItem, lessonIndex) in lessonRowItem.lessons"
            :key="lessonIndex">
            <div class="table-row-item lesson-content-item" v-for="(lessonDataItem, lessonDataIndex) in lessonItem"
              :key="lessonDataIndex" :id="lessonDataIndex" :style="lessonItemStyle(lessonItem.length, lessonDataItem)"
              @drop.prevent="
                dropSubject(lessonDataItem, lessonRowItem.lessonsSequence)
                " @dragover.prevent :draggable="lessonDataItem.scheduleState !== '0' ||
                  lessonDataItem.lessonsContent !== ''
                  " @dragstart="
                    autoMaticallyScheduleClassStatus
                      ? $event.preventDefault()
                      : courseItemDragStart(
                        lessonDataItem,
                        lessonRowItem.lessonsSequence
                      )
                    ">
              <el-popover trigger="click" placement="top" :disabled="lessonDataItem.lessonsContent == ''"
                :style="lessonItemStyle(lessonItem.length, lessonDataItem)">
                <p>课程：{{ lessonDataItem.lessonsContent }}</p>
                <p v-if="lessonDataItem.teacherName">
                  教师：{{ lessonDataItem.teacherName }}
                </p>
                <p v-if="lessonDataItem.classroomName">
                  课室：{{ lessonDataItem.classroomName }}
                </p>
                <div slot="reference" class="lesson-content-container">
                  <div class="content-course-name-container">
                    <span class="content-course-name">{{
                      lessonDataItem.lessonsContent
                    }}</span><br />
                    <span>{{
                      lessonDataItem.teacherName
                    }}</span>
                  </div>
                </div>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 10px; text-align: center">
      <el-button @click="classRearrange" type="primary" v-if="!autoMaticallyScheduleClassStatus">
        返回
      </el-button>
      <el-button @click="saveSchedule" type="primary" v-if="!autoMaticallyScheduleClassStatus">
        保存
      </el-button>
      <el-button @click="regenerate" type="primary" v-if="!autoMaticallyScheduleClassStatus">
        重新生成
      </el-button>
      <!-- <el-button v-if="autoMaticallyScheduleClassStatus" @click="classRearrange" type="primary"
        v-hasPermi="'sc:coursearrange:edit'">
        重新排课
      </el-button> -->
    </div>
    <!-- 课程冲突提示 -->
    <div style="margin-top: 10px;" v-if="messagesShow">
      <h1 class="title">课程冲突：</h1>
      <p style="font-size: 18px; margin-top: 8px" v-for="(item, index) in messagesArray" :key="index">
        {{ index + 1 }}.&nbsp;&nbsp;{{ item }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    autoMaticallyScheduleClassStatus: {
      typeof: Boolean,
    },
    autoMaticList: {
      typeof: Array,
    },
    courseConstructionNum: {
      typeof: Number,
    },
    weekLabelWidthVal: {
      typeof: Number,
    },
    messagesShow: {
      typeof: Boolean,
    },
    messagesArray: {
      typeof: Array,
    },
    gradeSelect: {
      typeof: Object,
    },
  },
  data() {
    return {
      days: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
      courseSchedule: [],
      // 自动排课表格tab的绑定数据
      currentTabName: "",
      lessonsList: [],
      applyExchangeWeek: null, // 申请交换的科目数据
      applyExchangeData: null, // 申请交换的课节数据
      classList: [],
      weekLabelWidth: 0,
    };
  },
  watch: {
    autoMaticList(arr) {
      // console.log("arr:", arr);
      if (arr.length && this.courseConstructionNum !== 0) {
        this.classList = arr;
        this.currentTabName = arr[0].className;
        this.courseSchedule = this.transformDataConvert(arr);
        // this.courseSchedule = this.transformDataToCourseSchedule(arr);
        // this.transformDataConvert(arr);
        // console.log("this.courseSchedule==>", this.courseSchedule);
        // console.log("this.classList==>", this.classList);
      } else {
        this.courseSchedule = [];
        this.classList = [];
      }
    },
  },
  mounted() {
    if (!this.autoMaticList.length) return;
    this.currentTabName = "" + this.autoMaticList[0].className;
  },
  methods: {
    regenerate() {
      this.get(this.$url.getAutoSchedulingCondition + '?gradeId=' + this.gradeSelect.gradeId).then((res) => {
        if (res.code !== 200 || res.data == null) return;
        let data = {
          schoolId: this.user.schoolId,
          schoolName: this.user.schoolName,
          gradeId: this.gradeSelect.gradeId,
          gradeCode: this.gradeSelect.gradeCode,
          gradeName: this.gradeSelect.gradeName,
          classInfo: res.data.classInfo,
        };
        this.post(this.$url.automaticCourseScheduling, data).then((res) => {
          this.$emit("automaticCourseScheduling", res);
        });
      });
    },
    //课程单元格样式
    lessonItemStyle(length, lessonDataItem) {
      // if (lessonDataItem.issueLessons == 1) {
      //   return {
      //     width: `${(this.weekLabelWidthVal - 1) / length}px`,
      //     backgroundColor: lessonDataItem.backgroundColor,
      //   };
      // }
      // return {
      //   width: `${(this.weekLabelWidthVal - 1) / length}px`,
      //   backgroundColor:
      //     lessonDataItem.lessonsContent === ""
      //       ? ""
      //       : lessonDataItem.scheduleState === "0"
      //         ? "rgb(179,184,193)"
      //         : lessonDataItem.backgroundColor,
      // };
      if (lessonDataItem.issueLessons == 1) {
        return {
          width: `110px`,
          backgroundColor: lessonDataItem.backgroundColor,
        };
      }
      return {
        width: `110px`,
        backgroundColor:
          lessonDataItem.lessonsContent === ""
            ? ""
            : lessonDataItem.scheduleState === "0"
              ? "rgb(179,184,193)"
              : lessonDataItem.backgroundColor,
      };
    },
    weekItemStyle() {
      return {
        width: `${this.classList.length * 110}px`,
      };
    },
    //数字转中文数字
    digitalToChineseWeek(number) {
      // 判断是否为数字
      if (isNaN(number)) return number;
      const digit_arr = [
        "",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ];
      let chineseNumber;
      if (number < 10) {
        chineseNumber = digit_arr[number];
      } else if (number >= 10 && number < 20) {
        let arr = number.toString().split("");
        chineseNumber = number == 10 ? "十" : `十${digit_arr[arr[1]]}`;
      } else {
        let arr = number.toString().split("");
        chineseNumber = `${digit_arr[arr[0]]}十${digit_arr[arr[1]]}`;
      }
      return chineseNumber;
    },
    // // 重新排课
    classRearrange() {
      // if (this.courseConstructionNum == 0)
      //   return this.$message.warning("暂无课时，请前往课程计划设置！");
      this.$emit("classRearrange");
    },
    // 开始拖动科目时记录拖动的科目ID
    courseItemDragStart(data, lessonsSequence) {
      // console.log("1", data[day]);
      if (data.scheduleState == "0")
        return this.$message.warning("该课程不参与排课，请前往课程计划修改");
      data["lessonsSequence"] = lessonsSequence;
      this.applyExchangeData = data;
    },
    dropSubject(data, lessonsSequence) {
      // console.log(this.applyExchangeData, data);

      // 筛选出与调换前课程 课节相同的被调换当天其他班级的课程数据
      // let swapSession = this.courseSchedule[0].scheduleList.find(
      //   (item) => item.lessonsSequence === lessonsSequence
      // ).lessons[data.week - 1];
      // // 筛选出与调换后课程 课节相同的调换前当天其他班级的课程数据
      // let preSwapSession = this.courseSchedule[0].scheduleList.find(
      //   (item) =>
      //     item.lessonsSequence === this.applyExchangeData.lessonsSequence
      // ).lessons[this.applyExchangeData.week - 1];
      // // 检测其他班级的课程数据中是否有与交换前数据相同教师的课程
      // const hasMatchingTeacher = swapSession.some((item) => {
      //   return (
      //     item.className !== this.applyExchangeData.className &&
      //     item.teacherName === this.applyExchangeData.teacherName &&
      //     item.teacherNumber === this.applyExchangeData.teacherNumber
      //   );
      // });
      // // 检测其他班级的课程数据中是否有与交换后数据相同教师的课程
      // const beSwitchedClasseshasMatchingTeacher = preSwapSession.some(
      //   (item) => {
      //     return (
      //       item.className !== data.className &&
      //       item.teacherName === data.teacherName &&
      //       item.teacherNumber === data.teacherNumber
      //     );
      //   }
      // );
      // console.log(swapSession, hasMatchingTeacher, this.applyExchangeData);
      if (data.classId !== this.applyExchangeData.classId)
        return this.$message.warning("只支持同一班级课程调换");

      if (data.lessonsContent == this.applyExchangeData.lessonsContent)
        return this.$message.warning("同科目不支持调换");

      if (data.lessonsContent == "" || data.scheduleState == "0")
        return this.$message.warning("目标课程不参与排课，请重新选择");
      // 交换后的课节当天该老师是否在其他班有课程编排
      // if (hasMatchingTeacher)
      //   return this.$message.warning(
      //     `星期${data.week}第${lessonsSequence}节${this.applyExchangeData.teacherName}老师已有其它课程安排，请重新选择`
      //   );
      // // 交换前的课节当天该老师是否在其他班有课程编排
      // if (beSwitchedClasseshasMatchingTeacher)
      //   return this.$message.warning(
      //     `星期${this.applyExchangeData.week}第${this.applyExchangeData.lessonsSequence}节${data.teacherName}老师已有其它课程安排，请重新选择`
      //   );
      let requestData = {
        skipCheck: false,
        applyExchange: {
          classId: this.applyExchangeData.classId,
          className: this.applyExchangeData.className,
          gradeId: this.autoMaticList[0].gradeId,
          gradeName: this.autoMaticList[0].gradeName,
          teacherId: this.applyExchangeData.teacherId,
          teacherName: this.applyExchangeData.teacherName,
          classroomId: this.applyExchangeData.classroomId,
          classroomName: this.applyExchangeData.classroomName,
          week: this.applyExchangeData.week,
          lessons: this.applyExchangeData.lessonsSequence,
          scheduleState: this.applyExchangeData.scheduleState,
          lessonsContent: this.applyExchangeData.lessonsName,
          courseId: this.applyExchangeData.courseId,
          courseName: this.applyExchangeData.courseName,
        },
        passivityExchange: {
          classId: data.classId,
          className: data.className,
          gradeId: this.autoMaticList[0].gradeId,
          gradeName: this.autoMaticList[0].gradeName,
          teacherId: data.teacherId,
          teacherName: data.teacherName,
          classroomId: data.classroomId,
          classroomName: data.classroomName,
          week: data.week,
          lessons: lessonsSequence,
          scheduleState: data.scheduleState,
          lessonsContent: data.lessonsName,
          courseId: data.courseId,
          courseName: data.courseName,
        },
      };

      // console.log("requestData:", requestData);


      // 调取手动调课检查接口
      this.post(this.$url.courseArrangeExchangeCheck, requestData).then(
        (res) => {
          const handleResponse = (msg) => {
            // 接口返回正常后，交换两个对象的数据
            const temp = JSON.parse(JSON.stringify(data));

            // 冲突课程调换之后更给颜色
            if (this.applyExchangeData.issueLessons == 1) {
              this.applyExchangeData.backgroundColor = "#b3b8c1";
            };

            if (temp.issueLessons == 1) {
              temp.backgroundColor = "#b3b8c1";
            };

            // 使用 Vue.set 或 this.$set 更新对象的属性
            Object.keys(data).forEach((key) => {
              if (key !== "week") {
                this.$set(data, key, this.applyExchangeData[key]);
              }
            });

            Object.keys(temp).forEach((key) => {
              if (key !== "week") {
                this.$set(this.applyExchangeData, key, temp[key]);
              }
            });
          };

          if (res.code !== 200) {
            // 将 res.msg 数组转换为多行字符串
            const message = res.data.join('<br>');
            this.$alert(message, "课程冲突提醒", {
              confirmButtonText: "继续安排",
              cancelButtonText: "取消",
              type: "warning",
              confirmButtonClass: "confirm",
              dangerouslyUseHTMLString: true
            }).then(() => {
              let skipCheckData = {
                skipCheck: true,
                applyExchange: {
                  classId: this.applyExchangeData.classId,
                  className: this.applyExchangeData.className,
                  gradeId: this.autoMaticList[0].gradeId,
                  gradeName: this.autoMaticList[0].gradeName,
                  teacherId: this.applyExchangeData.teacherId,
                  teacherName: this.applyExchangeData.teacherName,
                  classroomId: this.applyExchangeData.classroomId,
                  classroomName: this.applyExchangeData.classroomName,
                  week: this.applyExchangeData.week,
                  lessons: this.applyExchangeData.lessonsSequence,
                  scheduleState: this.applyExchangeData.scheduleState,
                  lessonsContent: this.applyExchangeData.lessonsName,
                  courseId: this.applyExchangeData.courseId,
                  courseName: this.applyExchangeData.courseName,
                },
                passivityExchange: {
                  classId: data.classId,
                  className: data.className,
                  gradeId: this.autoMaticList[0].gradeId,
                  gradeName: this.autoMaticList[0].gradeName,
                  teacherId: data.teacherId,
                  teacherName: data.teacherName,
                  classroomId: data.classroomId,
                  classroomName: data.classroomName,
                  week: data.week,
                  lessons: lessonsSequence,
                  scheduleState: data.scheduleState,
                  lessonsContent: data.lessonsName,
                  courseId: data.courseId,
                  courseName: data.courseName,
                },
              };

              // 调取手动调课检查接口
              this.post(this.$url.courseArrangeExchangeCheck, skipCheckData).then(
                (res) => {
                  if (res.code !== 200) return this.$message.error(res.msg);
                  handleResponse();
                });
            }).catch(() => { });
            return;
          };

          handleResponse();
          // this.applyExchangeData = temp;
        }
      );

      // console.log("调换后数据", data, this.applyExchangeData);
      // console.log("调换后数据", this.courseSchedule[0]);
    },
    transformDataConvert(data) {
      // console.log("data:", data);
      let result = JSON.parse(
        JSON.stringify([
          {
            gradeCode: data[0].gradeCode,
            gradeId: data[0].gradeId,
            gradeName: data[0].gradeName,
            schoolId: data[0].schoolId,
            schoolName: data[0].schoolName,
            scheduleList: data[0].scheduleList,
          },
        ])
      );
      // console.log("result:", result);

      result.forEach((item) => {
        item.scheduleList.forEach((itemS) => {
          itemS.lessons = itemS.lessons.map(() => []); // 将 lessons 数组中的每个 lessonItem 替换为一个包含空数组的数组

          // 在 data.scheduleList 中查找对应的 schedule
          data.forEach((dItem) => {
            const dItemS = dItem.scheduleList.find(
              (dItemS) => dItemS.startTime === itemS.startTime
            );

            if (dItemS) {
              dItemS.lessons.forEach((fItem) => {
                // console.log("item:", fItem.week);
                const targetArray = itemS.lessons[fItem.week - 1];

                // 判断数组长度是否已经等于 this.classList.length，如果是，则不再执行添加操作
                if (targetArray.length === this.classList.length) {
                  return;
                }

                targetArray.push(fItem);
              });
            }
          });
        });
      });

      return result;
    },
    // 数据格式转换
    transformDataToCourseSchedule(data) {
      const result = {};

      // 遍历data，将每一项的gradeCode和classCode作为key，构建新的对象
      data.forEach((classData) => {
        const classKey = `${classData.gradeCode}_${classData.classCode}`;

        // 如果result中不存在该key，则添加该key
        if (!result[classKey]) {
          result[classKey] = {
            // 添加该key对应的属性
            schoolId: classData.schoolId,
            schoolName: classData.schoolName,
            gradeId: classData.gradeId,
            gradeCode: classData.gradeCode,
            gradeName: classData.gradeName,
            classId: classData.classId,
            className: classData.className,
            scheduleList: [],
          };
        }

        // 遍历每一项classData的scheduleList，将每一项lessonsData的lessonsName作为key，构建新的对象
        classData.scheduleList.forEach((lessonsData) => {
          // 添加该key对应的属性
          const lessonsInfo = {
            lessonsName: lessonsData.lessonsName,
            lessonsSequence:
              lessonsData.lessonsSequence == "-1"
                ? ""
                : lessonsData.lessonsSequence,
            lessonsTime: `${lessonsData.startTime} - ${lessonsData.endTime}`,
            周一: {
              subject: "",
              scheduleState: "",
              teacherId: "",
              teacherNumber: "",
              teacherName: "",
              classroomId: "",
              classroomName: "",
            },
            周二: {
              subject: "",
              scheduleState: "",
              teacherId: "",
              teacherNumber: "",
              teacherName: "",
              classroomId: "",
              classroomName: "",
            },
            周三: {
              subject: "",
              scheduleState: "",
              teacherId: "",
              teacherNumber: "",
              teacherName: "",
              classroomId: "",
              classroomName: "",
            },
            周四: {
              subject: "",
              scheduleState: "",
              teacherId: "",
              teacherNumber: "",
              teacherName: "",
              classroomId: "",
              classroomName: "",
            },
            周五: {
              subject: "",
              scheduleState: "",
              teacherId: "",
              teacherNumber: "",
              teacherName: "",
              classroomId: "",
              classroomName: "",
            },
            周六: {
              subject: "",
              scheduleState: "",
              teacherId: "",
              teacherNumber: "",
              teacherName: "",
              classroomId: "",
              classroomName: "",
            },
            周日: {
              subject: "",
              scheduleState: "",
              teacherId: "",
              teacherNumber: "",
              teacherName: "",
              classroomId: "",
              classroomName: "",
            },
          };
          // 遍历每一项lessonsData的lessons，将每一项lesson的week和lessonsContent作为key，构建新的对象
          lessonsData.lessons.forEach((lesson) => {
            const dayOfWeek = this.getChineseDayOfWeek(lesson.week);
            lessonsInfo[dayOfWeek].subject = lesson.lessonsContent;
            lessonsInfo[dayOfWeek].scheduleState = lesson.scheduleState;
            lessonsInfo[dayOfWeek].teacherId = lesson.teacherId;
            lessonsInfo[dayOfWeek].teacherNumber = lesson.teacherNumber;
            lessonsInfo[dayOfWeek].teacherName = lesson.teacherName;
            lessonsInfo[dayOfWeek].classroomId = lesson.classroomId;
            lessonsInfo[dayOfWeek].classroomName = lesson.classroomName;
            lessonsInfo[dayOfWeek].courseId = lesson.courseId;
          });

          // 将构建好的lessonsInfo添加到result[classKey]的scheduleList中
          result[classKey].scheduleList.push({ ...lessonsInfo });
        });
      });

      // 返回result中所有的值
      return Object.values(result);
    },
    getChineseDayOfWeek(week) {
      switch (week) {
        case 1:
          return "周一";
        case 2:
          return "周二";
        case 3:
          return "周三";
        case 4:
          return "周四";
        case 5:
          return "周五";
        case 6:
          return "周六";
        case 7:
          return "周日";
        default:
          return "";
      }
    },
    saveSchedule() {
      // console.log("this.courseSchedule:", this.courseSchedule);
      // let data = JSON.parse(JSON.stringify(this.courseSchedule));
      // data.forEach((item) => {
      //   item.scheduleList = this.convertScheduleFormat(item.scheduleList);
      // });
      // let data = this.transformDataBack(this.courseSchedule);
      // console.log("data:", this.courseSchedule, this.classList);
      let data = this.classList;

      // console.log("data:", data);
      this.post(this.$url.saveCourseArrangeListPC, data).then((res) => {
        if (res.code !== 200) return this.$message.error(res.msg);
        // console.log("生成年级课表==>", res.data);
        this.$message.success(res.msg);
        this.$emit("autoMaticallyScheduleClassStatusChange", true);
      });
    },
    // 将数据转换成保存时所需的格式
    convertScheduleFormat(scheduleList) {
      // console.log("scheduleList:", scheduleList);
      return scheduleList.map((schedule) => {
        const lessons = [];

        for (let week = 1; week <= 7; week++) {
          const lessonInfo = schedule[this.getChineseDayOfWeek(week)];
          // console.log("lessonInfo:", lessonInfo);

          lessons.push({
            week,
            lessonsContent: lessonInfo ? lessonInfo.subject : "",
            scheduleState: lessonInfo ? lessonInfo.scheduleState : "0",
            courseId: lessonInfo ? lessonInfo.courseId : null,
            courseName: lessonInfo ? lessonInfo.subject : null,
            teacherId: lessonInfo ? lessonInfo.teacherId : null,
            teacherNumber: lessonInfo ? lessonInfo.teacherNumber : null,
            teacherName: lessonInfo ? lessonInfo.teacherName : null,
            classroomId: lessonInfo ? lessonInfo.classroomId : null,
            classroomName: lessonInfo ? lessonInfo.classroomName : null,
          });
        }

        return {
          lessonsName: schedule.lessonsName,
          lessonsSequence: schedule.lessonsSequence,
          startTime: schedule.lessonsTime
            ? schedule.lessonsTime.split(" - ")[0]
            : "",
          endTime: schedule.lessonsTime
            ? schedule.lessonsTime.split(" - ")[1]
            : "",
          lessons,
        };
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "./grade-schedule.scss";
</style>